import { render } from "./entrepreneurshipMentor.vue?vue&type=template&id=7f235d49&scoped=true"
import script from "./entrepreneurshipMentor.vue?vue&type=script&lang=js"
export * from "./entrepreneurshipMentor.vue?vue&type=script&lang=js"

import "./entrepreneurshipMentor.vue?vue&type=style&index=0&id=7f235d49&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f235d49"]])

export default __exports__